export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'TRACKS_SET':
    return payload
  case 'TRACK_CREATE':
    return [payload, ...state]
  case 'TRACK_UPDATE':
    return state.map(item => (item.id == payload.id ? payload : item))
  case 'TRACK_DELETE':
    return state.filter(item => item.id != payload)
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
